import { render, staticRenderFns } from "./WaiterRegister.vue?vue&type=template&id=51f58d08&scoped=true&lang=pug"
import script from "./WaiterRegister.vue?vue&type=script&lang=ts"
export * from "./WaiterRegister.vue?vue&type=script&lang=ts"
import style0 from "./WaiterRegister.vue?vue&type=style&index=0&id=51f58d08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f58d08",
  null
  
)

export default component.exports